module.exports = {
	"config": {
		"siteTitle": "AlphabetJS",
		"baseColor": "#884499",
		"linkPrefix": "/gatsby-starter-documentation",
		"docPages": [
			"/docs/",
			"/docs/getting-started/",
			"/docs/how-to-run/",
			"/docs/some-react-code/",
			"/docs/the-next-step/",
			"/docs/conclusion/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx"
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/conclusion",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/conclusion",
				"stem": "index",
				"path": "docs/conclusion/index.md"
			},
			"requirePath": "docs/conclusion/index.md",
			"path": "/docs/conclusion/",
			"data": {
				"title": "Conclusion"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/getting-started",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/getting-started",
				"stem": "index",
				"path": "docs/getting-started/index.md"
			},
			"requirePath": "docs/getting-started/index.md",
			"path": "/docs/getting-started/",
			"data": {
				"title": "Getting Started"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/how-to-run",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/how-to-run",
				"stem": "index",
				"path": "docs/how-to-run/index.md"
			},
			"requirePath": "docs/how-to-run/index.md",
			"path": "/docs/how-to-run/",
			"data": {
				"title": "How to Run"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs",
				"stem": "index",
				"path": "docs/index.md"
			},
			"requirePath": "docs/index.md",
			"path": "/docs/",
			"data": {
				"title": "Introduction"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/some-react-code",
				"base": "_Demo.jsx",
				"ext": "jsx",
				"name": "_Demo",
				"extname": ".jsx",
				"basename": "_Demo.jsx",
				"dirname": "docs/some-react-code",
				"stem": "_Demo",
				"path": "docs/some-react-code/_Demo.jsx"
			},
			"requirePath": "docs/some-react-code/_Demo.jsx",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/some-react-code",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "docs/some-react-code",
				"stem": "index",
				"path": "docs/some-react-code/index.jsx"
			},
			"requirePath": "docs/some-react-code/index.jsx",
			"path": "/docs/some-react-code/",
			"data": {
				"title": "Some React Code"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/the-next-step",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/the-next-step",
				"stem": "index",
				"path": "docs/the-next-step/index.md"
			},
			"requirePath": "docs/the-next-step/index.md",
			"path": "/docs/the-next-step/",
			"data": {
				"title": "The Next Step"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "examples",
				"stem": "index",
				"path": "examples/index.md"
			},
			"requirePath": "examples/index.md",
			"path": "/examples/",
			"data": {
				"title": "Modules used on this site"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "AlphabetJS: The latest and greatest Javascript framework"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0